import { faBitbucket } from '@fortawesome/free-brands-svg-icons/faBitbucket';
import { faCodeBranch } from '@fortawesome/pro-regular-svg-icons/faCodeBranch';
import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faGitlab } from '@fortawesome/free-brands-svg-icons/faGitlab';
import { faWindows } from '@fortawesome/free-brands-svg-icons/faWindows';

export function iconForProviderId(providerId) {
  switch (providerId) {
    case 1: {
      return faGithub;
    }
    case 2: {
      return faBitbucket;
    }
    case 3: {
      return faGitlab;
    }
    case 4: {
      return faCodeBranch;
    }
    case 6: {
      return faWindows;
    }
    default: {
      return null;
    }
  }
}

const CLOUD_PROVIDERS = {
  github: 1,
  bitbucket: 2,
  gitlab: 3,
  azuredevops: 6,
};

export function isCloudProvider(provider) {
  // check if value given is name of providers
  if (typeof provider === 'string') {
    provider = provider.toLowerCase();
  }
  if (provider in CLOUD_PROVIDERS) {
    return true;
  }
  // check if value given is id of provider
  return Object.values(CLOUD_PROVIDERS).includes(parseInt(provider));
}

const PROVIDER_ID_MAP = {
  github: 1,
  bitbucket: 2,
  gitlab: 3,
  onprem: 4,
  azuredevops: 6,
};

export function idForProvider(provider) {
  return PROVIDER_ID_MAP[provider];
}

const PROVIDER_DISPLAY_NAME_MAP = {
  github: 'GitHub',
  bitbucket: 'Bitbucket',
  gitlab: 'GitLab',
  onprem: 'OnPrem',
  azuredevops: 'Azure DevOps',
  hackerone: 'HackerOne',
};

export function displayNameForProvider(provider) {
  return PROVIDER_DISPLAY_NAME_MAP[provider];
}

const PROVIDER_COLOR_MAP = {
  github: '#464646',
  bitbucket: '#0052cc',
  gitlab: '#fa7035',
  azuredevops: '#0078d4',
  hackerone: '#ffffff',
};

export function displayColorForProvider(provider) {
  return PROVIDER_COLOR_MAP[provider];
}

export function pullRequestNameforProvider(provider, capitalize) {
  if (capitalize) {
    return provider === 'gitlab' ? 'Merge Request' : 'Pull Request';
  }
  return provider === 'gitlab' ? 'merge request' : 'pull request';
}

export function getPluralReviewWording(provider, capitalize) {
  if (capitalize) {
    return provider === 'gitlab' ? 'Merge Requests' : 'Pull Requests';
  }
  return provider === 'gitlab' ? 'merge requests' : 'pull requests';
}

// TODO: Add a help link for Azure DevOps and OnPrem
const PROVIDER_CONNECTING_HELP_MAP = {
  gitlab:
    'https://support.pullrequest.com/hc/en-us/articles/360009428054-My-GitLab-Project-isn-t-showing-up-in-PullRequest',
  github:
    'https://support.pullrequest.com/hc/en-us/articles/115005021074-My-GitHub-repository-isn-t-showing-up-in-PullRequest',
  bitbucket:
    'https://support.pullrequest.com/hc/en-us/articles/360000966474-My-Bitbucket-repository-isn-t-showing-up-in-PullRequest',
};

export function connectingSupportURLForProvider(provider) {
  return PROVIDER_CONNECTING_HELP_MAP[provider];
}

// TODO: Add link to Azure DevOps code
export function getLinkToProviderLineOfCode(
  providerId,
  projectURL,
  defaultBranch,
  path,
  lineNumber,
  onPremProviderName,
  addedSha = ''
) {
  const GITHUB_OR_GITLAB_ALL_URL = `${projectURL}/blob/${
    addedSha || defaultBranch
  }/${path}#L${lineNumber}`;
  const BITBUCKET_CLOUD_URL = `${projectURL}/src/${
    addedSha || defaultBranch
  }/${path}#lines-${lineNumber}`;
  // TODO: Fix this for all onprem providers
  const BITBUCKET_ONPREM_URL = addedSha
    ? `${projectURL}/${path}?at=${addedSha}#${lineNumber}`
    : `${projectURL}/${path}#${lineNumber}`;

  const onPremProviderId = idForProvider(onPremProviderName);
  const { github, bitbucket, gitlab, onprem } = PROVIDER_ID_MAP;

  if (providerId === github || providerId === gitlab) {
    return GITHUB_OR_GITLAB_ALL_URL;
  } else if (providerId === bitbucket) {
    return BITBUCKET_CLOUD_URL;
  } else if (providerId === onprem) {
    if (onPremProviderId === github || onPremProviderId === gitlab) {
      return GITHUB_OR_GITLAB_ALL_URL;
    } else if (onPremProviderId === bitbucket) {
      return BITBUCKET_ONPREM_URL;
    }
  }
  return '';
}

//TODO: Add support for onprem and Azure DevOps provider links
export function getLinkToBranch(branch, organization, project) {
  const orgName = organization.name;
  const orgSlug = organization.slug;
  const projectName = project.name;
  switch (organization.provider) {
    case 'github':
      return `https://github.com/${orgName}/${projectName}/tree/${branch}`;
    case 'bitbucket':
      return `https://bitbucket.org/${orgSlug}/${projectName}/branch/${branch}`;
    case 'gitlab':
      return `https://gitlab.com/${orgSlug}/${projectName}/tree/${branch}`;
    default:
      return null;
  }
}
